import { observer } from 'mobx-react-lite'
import CellPickerHOC from '../cellPickerHOC/cellPickerHOC'
import usersStore from '../../store/users'
import stageStore from '../../store/stage'
import dashbordStore from '../../store/dashbord'
import useSettings from '../../hooks/settings.hook'

const Cell = ({ current, currentData, small, multi }) => {
  return current ? (
    <div
      className={`

			${multi ? 'px-[1.2rem] py-[0.2rem] text-Regular(16_18)' : small ? 'px-[1.2rem] py-[0.2rem]' : 'px-[1.2rem] py-[0.9rem]'}
			 h-[100%] flex items-center`}>
      {current?.username || currentData.username}
    </div>
  ) : (
    <div
      className={`
		${multi ? 'px-[1.2rem] py-[0.2rem] text-Regular(16_18)' : small ? 'px-[1.2rem] py-[0.2rem]' : 'px-[1.2rem] py-[0.9rem]'}
		text-Accent/Red font-medium  h-[100%] flex items-center`}>
      Выбрать
    </div>
  )
}

const renderItem = (onClickHandler, { favoriteUserIds = [], onToggleFavorite } = {}) => item => {
  const isFavorite = favoriteUserIds.includes(item.id)

  return (
    <span
      key={item.id}
      className=' flex justify-between items-center px-[1.2rem] py-[1.2rem]'>
      <span
        onClick={ev => {
          ev.stopPropagation()
          onClickHandler(item)
        }}
        className="hover:opacity-60 ease-in-out duration-300 ">
        {item.username}
      </span>
      <span
        onClick={ev => {
          ev.stopPropagation()
          onToggleFavorite?.(item.id)
        }}
        className={`hover:text-Accent/Yellow text-Regular(18_24)  w-[2rem] h-[2rem] flex items-center justify-center hover:cursor-pointer ease-in-out duration-300 ${
          isFavorite ? 'text-Accent/Yellow' : ''
        }`}>
        <i className={isFavorite ? 'icon-bookmark-active' : 'icon-bookmark'}></i>
      </span>
    </span>
  )
}

const UserCellPicker = CellPickerHOC(renderItem, Cell)

function PositionUser({ onSetUserHandler, ...props }) {
  const { toggleFavoriteUser } = useSettings()
  const favoriteUserIds = dashbordStore.settings.favoriteUserIds || []

  if (!props.data) {
    const stageRoles = stageStore.stages.find(x => x.id === props.stageId)?.m_roles || []
    const stageRoleIds = stageRoles.map(role => role.id)
    const users = usersStore.users.filter(x => x.m_roles.some(y => stageRoleIds.includes(y.id)))
    props.data = users
  }

  const favoriteIndex = new Map(favoriteUserIds.map((id, index) => [id, index]))
  props.data = [...props.data].sort((a, b) => {
    const aIndex = favoriteIndex.has(a.id) ? favoriteIndex.get(a.id) : Infinity
    const bIndex = favoriteIndex.has(b.id) ? favoriteIndex.get(b.id) : Infinity
    return aIndex - bIndex
  })

  if (props.service) {
    return null
  }

  return (
    <UserCellPicker
      {...props}
      favoriteUserIds={favoriteUserIds}
      onToggleFavorite={toggleFavoriteUser}></UserCellPicker>
  )
}

export default observer(PositionUser)
